import { t } from 'i18next';

import { IOrganizationContractModel } from '../../../models/OrganizationContractModel';

export const getContractsOptions = (contracts: IOrganizationContractModel[]) =>
  (contracts || []).map(({ id, name, contractType }) => ({
    label: `${name} - ${t(`enums.contract-type.${contractType}`)}`,
    value: id,
  }));
